import React from "react";
import { theme } from "../../theme";

export default function NotificationBell({ unreadCount = 0, onClick }) {
  const label =
    unreadCount > 0
      ? `${unreadCount} unread notification${unreadCount === 1 ? "" : "s"}`
      : "No unread notifications";

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      title={label}
      style={styles.button}
    >
      <span aria-hidden="true" style={styles.icon}>
        🔔
      </span>

      {unreadCount > 0 && (
        <span style={styles.badge}>{unreadCount > 99 ? "99+" : unreadCount}</span>
      )}
    </button>
  );
}

const styles = {
  button: {
    position: "relative",
    width: "40px",
    height: "40px",
    display: "grid",
    placeItems: "center",
    borderRadius: theme.radius.pill,
    border: `1px solid ${theme.colors.border}`,
    background: theme.colors.card,
    cursor: "pointer",
    boxShadow: theme.shadow.soft
  },
  icon: {
    fontSize: "18px",
    lineHeight: 1
  },
  badge: {
    position: "absolute",
    top: "-5px",
    right: "-5px",
    minWidth: "19px",
    height: "19px",
    padding: "0 5px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: theme.radius.pill,
    border: "2px solid #ffffff",
    background: theme.colors.danger,
    color: "#ffffff",
    fontSize: "10px",
    fontWeight: 900
  }
};
